var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-progress-linear"},[_c('div',{staticClass:"w-progress-linear-progress",class:{undetermind: _vm.undetermind},style:({width: _vm.width, backgroundColor:_vm.color})})])
}
var staticRenderFns = []

export { render, staticRenderFns }